import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';

import { Button } from 'uikit/buttons';

import UserDetailsRow from './userDetailsRow';

import styles from '../styles/userSelect.module.scss';

const UserSelectOption = ({
  data = { avatar: { url: '' }, code: '', id: null, name: '', position: '' },
  ...props
}) => {
  const {
    name, position, code, avatar: { url },
  } = data;

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.Option data={data} {...props}>
      <UserDetailsRow
        name={name}
        position={position}
        code={code}
        avatarUrl={url}
      />
      {props.isSelected && <Check sx={{ height: 18, width: 18 }} />}
    </components.Option>
  );
};

UserSelectOption.propTypes = {
  data: PropTypes.shape({
    avatar: PropTypes.shape({ url: PropTypes.string }),
    code: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    position: PropTypes.string,
  }),
};

const UserSelectedOption = ({
  handleRemoveSelected = () => {},
  isReadOnly = false,
  selectedItem: { avatar, code, id, name, picture, position },
}) => (
  <li className={styles.selectedOption}>
    <UserDetailsRow
      name={name}
      position={position}
      code={code}
      avatarUrl={avatar?.url || picture?.thumb}
    />
    {!isReadOnly && (
      <Button
        className={styles.removeButton}
        variant="ghost"
        size="xsmall"
        icon={<Close />}
        onClick={() => handleRemoveSelected(id)}
      />
    )}
  </li>
);

UserSelectedOption.propTypes = {
  selectedItem: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
  }).isRequired,
  isReadOnly: PropTypes.bool,
  handleRemoveSelected: PropTypes.func,
};

export { UserSelectOption, UserSelectedOption };
